

import React from 'react';


import { jobsText } from './../../text/jobs-text.js';

import { motion } from 'framer-motion';



const JobsTab = ({ opeLevel, conLevel, extLevel, agrLevel, staLevel, opeTitle, opeLogo, conTitle, conLogo, agrTitle,
    agrLogo, extTitle, extLogo, staTitle, staLogo, isPaid }) => {


    let opeText1;
    let opeText2;
    let opeText3;

    let conText1;
    let conText2;
    let conText3;

    let extText1;
    let extText2;
    let extText3;

    let agrText1;
    let agrText2;
    let agrText3;

    let staText1;
    let staText2;
    let staText3;


    if (opeLevel > 4) {
        opeText1 = jobsText.opeText1;
        opeText2 = jobsText.opeText2;
        opeText3 = jobsText.opeText3;

    }
    else if (opeLevel == 4) {
        opeText1 = jobsText.opeCloText1;
        opeText2 = jobsText.opeCloText1;
    }
    else {
        opeText1 = jobsText.cloText1;
        opeText2 = jobsText.cloText2;
        opeText3 = jobsText.cloText3;
    }

    if (conLevel > 4) {
        conText1 = jobsText.conText1;
        conText2 = jobsText.conText2;
        conText3 = jobsText.conText3;

    }
    else if (conLevel == 4) {
        conText1 = jobsText.conUncText1;
        conText2 = jobsText.conUncText2;
    }
    else {
        conText1 = jobsText.conText1;
        conText2 = jobsText.conText2;
        conText3 = jobsText.conText3;
    }

    if (extLevel > 4) {
        extText1 = jobsText.extText1;
        extText2 = jobsText.extText2;
        extText3 = jobsText.extText3;

    }
    else if (extLevel == 4) {
        extText1 = jobsText.extIntText1;
        extText2 = jobsText.extIntText2;
    }
    else {
        extText1 = jobsText.intText1;
        extText2 = jobsText.intText2;
        extText3 = jobsText.intText3;

    }

    if (agrLevel > 4) {
        agrText1 = jobsText.agrText1;
        agrText2 = jobsText.agrText2;
        agrText3 = jobsText.agrText3;

    }
    else if (agrLevel == 4) {
        agrText1 = jobsText.agrDisText1;
        agrText2 = jobsText.agrDisText2;
    }
    else {
        agrText1 = jobsText.disText1;
        agrText2 = jobsText.disText2;
        agrText3 = jobsText.disText3;

    }

    if (staLevel > 4) {
        staText1 = jobsText.staText1;
        staText2 = jobsText.staText2;
        staText3 = jobsText.staText3;
    }
    else if (opeLevel == 4) {
        staText1 = jobsText.staNeuText1;
        staText2 = jobsText.staNeuText2;

    }
    else {
        staText1 = jobsText.neuText1;
        staText2 = jobsText.neuText2;
        staText3 = jobsText.neuText3;

    }


    return (

        <motion.div className="result"
            initial={{ opacity: 0, y: -10 }}
            animate={
                { opacity: 1, y: 0, transition: { delay: 0.3 } }}
        >
            <>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={opeLogo} alt="logo" />
                        <div>
                            {opeTitle}
                        </div>
                    </h1>

                    <p> {opeText1} </p>

                    < div className="vertical-spacer" />


                    <p> {opeText2} </p>

                    < div className="vertical-spacer" />


                    <p> {opeText3}</p>
                    < div className="vertical-spacer" />
                    <hr />
                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={conLogo} alt="logo" />
                        <div>

                            {conTitle}
                        </div>
                    </h1>

                    <p> {conText1} </p>

                    < div className="vertical-spacer" />


                    <p> {conText2} </p>

                    < div className="vertical-spacer" />


                    <p> {conText3}</p>


                    < div className="vertical-spacer" />
                    <hr />
                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={extLogo} alt="logo" />
                        <div>
                            {extTitle}
                        </div>
                    </h1>

                    
                    <p> {extText1} </p>

                    < div className="vertical-spacer" />


                    <p> {extText2} </p>

                    < div className="vertical-spacer" />


                    <p> {extText3}</p>

                    < div className="vertical-spacer" />
                    <hr />

                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={agrLogo} alt="logo" />
                        <div>
                            {agrTitle}
                        </div>
                    </h1>

                    
                    <p> {agrText1} </p>

                    < div className="vertical-spacer" />


                    <p> {agrText2} </p>

                    < div className="vertical-spacer" />


                    <p> {agrText3}</p>

                    < div className="vertical-spacer" />
                    <hr />
                </div>
                <div>
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={staLogo} alt="logo" />
                        <div>
                            {staTitle}
                        </div>
                    </h1>

                    
                    <p> {staText1} </p>

                    < div className="vertical-spacer" />


                    <p> {staText2} </p>

                    < div className="vertical-spacer" />


                    <p> {staText3}</p>

                    < div className="vertical-spacer" />
                    <hr />
                </div>
            </>

        </motion.div>

    );



}

export default JobsTab;